// store.js
import { configureStore } from '@reduxjs/toolkit';
import rootReducer from '../reducers/rootReducers';
import { saveState, loadState } from  '../localStorage';

const preloadedState = loadState(); // Load state from localStorage

const store = configureStore({
  reducer: rootReducer,
  preloadedState,
});

// Debounce persistence: serializing the whole store on every dispatch is
// wasted work during bursts of actions. Flush on unload so nothing is lost.
let saveTimer;
store.subscribe(() => {
  clearTimeout(saveTimer);
  saveTimer = setTimeout(() => saveState(store.getState()), 250);
});

if (typeof window !== 'undefined') {
  window.addEventListener('beforeunload', () => {
    clearTimeout(saveTimer);
    saveState(store.getState());
  });
}

export default store;
